import { LoadingButtonProps, LoadingButton as MuiLoadingButton } from "@mui/lab";
import { forwardRef } from "react";

type Props = LoadingButtonProps;

export const LoadingButton = forwardRef<HTMLButtonElement, Props>(({ children, ...props }: Props, ref) => (
  <MuiLoadingButton ref={ref} {...props}>
    {children}
  </MuiLoadingButton>
));
LoadingButton.displayName = "LoadingButton";

export function AnyComponentLoadingButton<C extends React.ElementType>({ children, ...props }: LoadingButtonProps<C, { component?: C }>) {
  return <LoadingButton {...props}>{children}</LoadingButton>;
}
